import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "M26.666 1.667h-20A3.343 3.343 0 0 0 3.333 5v23.333h3.333V5h20zm5 6.666H13.333A3.343 3.343 0 0 0 10 11.666V35c0 1.833 1.5 3.333 3.333 3.333h18.333C33.5 38.333 35 36.833 35 35V11.667c0-1.834-1.5-3.334-3.334-3.334m0 26.667H13.333V11.667h18.333z",
    fill: "currentColor"
  }
) });
export {
  r as C
};
